import { ApiFabricator } from '@app/tests/utils/fabricators/ApiFabricator'

import type { ApiPolicy } from '@app/packages/api/v2/types/entities'

export class ApiPolicyFabricator extends ApiFabricator<ApiPolicy> {
  /**
   * `effective_from` is in the past on purpose: `policiesSelector` drops anything not yet in
   * force, so a policy dated now would fabricate an empty list rather than a policy.
   */
  protected getBase = (): ApiPolicy => ({
    type: 'policies',
    id: ApiFabricator.getId('policies'),
    attributes: {
      key: 'privacy',
      name: 'Политика конфиденциальности',
      version: '1.0',
      effective_from: '2020-01-01T00:00:00Z',
      effective_until: null,
      content_url: 'https://kidsout.ru/privacy',
      should_collect_consent: true,
    },
    relationships: { consent_types: { data: [{ id: 'data_processing', type: 'consent_types' }] } },
  })
}
